<app-layout-master [environment]="currentEnvironment"></app-layout-master>